
import { Vue, Component, Prop } from "vue-property-decorator";
import OxyClassToken from "@/oxygen/classes/OxyClassToken.vue";
import Icon from "@/components/UI/Icon.vue";
import draggable from "vuedraggable";
import { OxySelector } from "@/oxygen/classes/lib/types";

@Component({
  components: {
    Icon,
    draggable,
    OxyClassToken
  }
})
export default class SelectorsListItem extends Vue {
  @Prop()
  selector!: OxySelector;

  dragOptions = {
    animation: 200,
    filter: ".oxy-class-token-actions__button",
    ghostClass: "breakdance-repeater-item--ghost",
    forceFallback: true
  };

  get name() {
    return this.selector.type === "class"
      ? `.${this.selector.name}`
      : this.selector.name;
  }
}
